import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Fragment, useState, useMemo } from "react";
import { useBlocker } from "../../contexts";
import { BlockerBodyInlineStyles, BlockerInlineStyles, BlockerButton, BlockerGroupsInlineStyles, BlockerCookie } from ".";
import { getOtherOptionsFromWindow } from "../../utils";
import { expandGroupsServiceVariable } from "../../others";
import { BannerDevHint } from "../banner";

var BlockerBody = function BlockerBody() {
  var blocker = useBlocker();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      areCookiesVisible = _useState2[0],
      setCookiesVisible = _useState2[1];

  var isEPrivacyUSA = blocker.ePrivacyUSA,
      isAgeNotice = blocker.ageNotice,
      _blocker$decision = blocker.decision,
      acceptAll = _blocker$decision.acceptAll,
      acceptIndividual = _blocker$decision.acceptIndividual,
      _blocker$texts = blocker.texts,
      ePrivacyUSA = _blocker$texts.ePrivacyUSA,
      ageNoticeBlocker = _blocker$texts.ageNoticeBlocker,
      _blocker$blocker = blocker.blocker,
      description = _blocker$blocker.description,
      cookies = _blocker$blocker.cookies,
      consent = blocker.consent,
      groups = blocker.groups,
      onUnblock = blocker.onUnblock;

  var _getOtherOptionsFromW = getOtherOptionsFromWindow(),
      _getOtherOptionsFromW2 = _getOtherOptionsFromW.bannerI18n,
      close = _getOtherOptionsFromW2.close,
      loadBlockedContent = _getOtherOptionsFromW2.loadBlockedContent,
      showAllMissingCookies = _getOtherOptionsFromW2.showAllMissingCookies,
      unblockContentInfo = _getOtherOptionsFromW2.unblockContentInfo; // Calculate missing cookies


  var missing = useMemo(function () {
    var missing = [];
    var allConsentCookies = [];

    for (var _i = 0, _Object$values = Object.values(consent.groups); _i < _Object$values.length; _i++) {
      var _cookies = _Object$values[_i];
      allConsentCookies.push.apply(allConsentCookies, _toConsumableArray(_cookies));
    }

    var _iterator = _createForOfIteratorHelper(groups),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var items = _step.value.items;

        var _iterator2 = _createForOfIteratorHelper(items),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var cookie = _step2.value;

            // Cookie is needed for this blocker? Yes, check if already consent...
            if (cookies.indexOf(cookie.id) > -1 && allConsentCookies.indexOf(cookie.id) === -1) {
              missing.push(cookie);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return missing;
  }, [groups, cookies, consent]);
  var useEPrivacyUSA = expandGroupsServiceVariable(groups, isEPrivacyUSA ? ePrivacyUSA : "", function (_ref) {
    var ePrivacyUSA = _ref.ePrivacyUSA;
    return ePrivacyUSA;
  });
  var showDescriptionContainer = !!description || isEPrivacyUSA || isAgeNotice;
  return h("div", BlockerBodyInlineStyles.bodyContainer(blocker), h("div", BlockerBodyInlineStyles.body(blocker), h("div", BlockerInlineStyles.topSide(blocker), showDescriptionContainer && h("div", BlockerBodyInlineStyles.description(blocker), !!description && h(Fragment, null, h("span", {
    dangerouslySetInnerHTML: {
      __html: description.replace(/\n/gm, "<br />")
    }
  }), h("div", null, h("span", BlockerBodyInlineStyles.teachingsSeparator(blocker)))), (isEPrivacyUSA || isAgeNotice) && h(Fragment, null, !!useEPrivacyUSA && h("span", _extends({}, BlockerBodyInlineStyles.teaching(blocker), {
    dangerouslySetInnerHTML: {
      __html: useEPrivacyUSA
    }
  })), isAgeNotice && !!ageNoticeBlocker && h("span", _extends({}, BlockerBodyInlineStyles.teaching(blocker), {
    dangerouslySetInnerHTML: {
      __html: ageNoticeBlocker
    }
  })))), h(BlockerButton, {
    type: acceptIndividual === "hide" ? "link" : acceptIndividual,
    inlineStyle: "showInfo",
    onClick: function onClick() {
      return setCookiesVisible(!areCookiesVisible);
    }
  }, areCookiesVisible ? close : showAllMissingCookies), areCookiesVisible && h("div", BlockerGroupsInlineStyles.cookieScroll(blocker), missing.map(function (cookie) {
    return h(BlockerCookie, {
      key: cookie.id,
      cookie: cookie
    });
  })), h("div", BlockerInlineStyles.infoText(blocker), unblockContentInfo)), h("div", BlockerInlineStyles.bottomSide(blocker), h(BlockerButton, {
    type: acceptAll === "hide" ? "button" : acceptAll,
    inlineStyle: "save",
    onClick: function onClick() {
      return onUnblock();
    }
  }, loadBlockedContent), h(BannerDevHint, null))));
};

export { BlockerBody };